import forOwn from 'lodash/forOwn';
import values from 'lodash/values';
import localityState from './locality-state';
var localityNamePattern = '[\\w-]+';
var statePattern = () => {
  var states = [];
  forOwn(localityState, value => {
    states.push(value.abbreviation);
  });
  return "(".concat(states.join('|').toLowerCase(), ")");
};
var postcodePattern = '\\d{1,4}';
export var LocalityTypeName;
(function (LocalityTypeName) {
  LocalityTypeName["DIVISION"] = "DIVISION";
  LocalityTypeName["DISTRICT"] = "DISTRICT";
  LocalityTypeName["REGION"] = "REGION";
  LocalityTypeName["STREET"] = "STREET";
  LocalityTypeName["POSTCODE"] = "POSTCODE";
  LocalityTypeName["SCHOOL"] = "SCHOOL";
})(LocalityTypeName || (LocalityTypeName = {}));
var LocalityType = {
  DIVISION: {
    type: LocalityTypeName.DIVISION,
    slugPattern: new RegExp("^(".concat(localityNamePattern, "-").concat(statePattern(), "-").concat(postcodePattern, ")$"), 'i'),
    shortSlugReplacement: '$1',
    idField: 'divisionId',
    idPrefix: 12
  },
  DISTRICT: {
    type: LocalityTypeName.DISTRICT,
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-district-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'districtId',
    idPrefix: 11
  },
  REGION: {
    type: LocalityTypeName.REGION,
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-region-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'regionId',
    idPrefix: 10
  },
  STREET: {
    type: LocalityTypeName.STREET
  },
  POSTCODE: {
    type: LocalityTypeName.POSTCODE
  },
  SCHOOL: {
    type: LocalityTypeName.SCHOOL
  }
};
export var localityTypeByIdPrefix = idPrefix => values(LocalityType).find(localityType => localityType.idPrefix === parseInt(idPrefix, 10));
export default LocalityType;